import { useState, useEffect, forwardRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import PropTypes from 'prop-types';
import styledComponents from "styled-components";

import {
  Box,
  CircularProgress,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Select,
  Stack,
  Snackbar,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

import Countdown from 'react-countdown';

const Completionist = () => <span>Waktu PO telah habis</span>;

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <Completionist />;
  } else {
    // Render a countdown
  return <span>{days} h : {hours} j : {minutes} m : {seconds} d</span>;
  }
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: '70%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const PreOrder = ({ data, authData, opData, updatedData, updatedPoLink }) => {

    const [openModalPo, setOpenModalPo] = useState(false);
    const [openModalPoCustom, setOpenModalPoCustom] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [tmpIdproduk, setTmpIdproduk] = useState(null);
    const [valToSubmit, setValToSubmit] = useState({});
    const [poForm, setPoForm] = useState([]);
    const [stokInfo, setStokInfo] = useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const [withStok, setWithStok] = useState(false);
    const [openingModalPo, setOpeningModalPo] = useState(false);
    const navigate = useNavigate();

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleSubmitPo = (e) => {
        setSubmitting(true);
        e.preventDefault();
        let sum = 0;
        let sum238 = 0;
        const errorStok = [];
        console.log(stokInfo);
        if (withStok && stokInfo.length > 0) {
            stokInfo.forEach((item) => {
                let tmpAmount = 0;
                for (const [key, value] of Object.entries(valToSubmit)) {
                    if (item.idpo === valToSubmit[key].idpo && withStok ) {
                        tmpAmount += valToSubmit[key].value;
                        if(valToSubmit[key].idpoproduk === 238) sum238 += valToSubmit[key].value;
                    }
                    sum += valToSubmit[key].value;
                }
                if(item.stok < tmpAmount) {
                    errorStok.push(
                        {
                            idpo: item.idpo,
                            message: `Order ${item.namakategori} melebihi stok`
                        }
                    );
                }
            });
        } else {
            for (const [key, value] of Object.entries(valToSubmit)) {
                sum += valToSubmit[key].value;
                if(valToSubmit[key].idpoproduk === 238) sum238 += valToSubmit[key].value;
            }
        }

        if( Object.keys(valToSubmit).length === 0 || sum === 0) {
            setOpenAlert(true);
            setAlertStatus('warning');
            setAlertMessage('Data kosong !');
            setSubmitting(false);

        } else if (errorStok.length > 0 && withStok) {
            setOpenAlert(true);
            setAlertStatus('error');
            setAlertMessage('Order melebihi stok !');
            setSubmitting(false);

        } else if (sum238 > 6 && errorStok.length > 0 && withStok) {
            setOpenAlert(true);
            setAlertStatus('error');
            setAlertMessage('Order melebihi stok!' );
            setSubmitting(false);

        } else if (sum238 > 6 && errorStok.length === 0 && withStok) {
            setOpenAlert(true);
            setAlertStatus('error');
            setAlertMessage('Order maksimum ' + maxPcs+' pcs!' );
            setSubmitting(false);

        } else {
            
            const data = {
                stok: withStok,
                data: valToSubmit
            };

            const submitPo = async () => {
                try {
                    await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/create`, data, {
                        headers: {
                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                        }
                    });
                    handleCloseModalPo();

                    setOpenAlert(true);
                    setAlertStatus('success');
                    setAlertMessage('Permintaan pre-order telah dikirim !');
                    await getData();
                } catch (err) {
                    console.log(err);
                    setSubmitting(false);
                    setWithStok(false);
                }
            };

            const getData = async () => {
                try {
                    const polist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/list`, {
                        headers: {
                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                        }
                    });
                    let number = 0;
                    await updatedData(polist.data.result.map((v) => {
                        number+=1;
                        return { ...v, no: number };
                    }));
                    await getOpenedPo(polist.data.result);
                } catch (err) {
                    console.log(err);
                }
            };
    
            const getOpenedPo = async (listed) => {
                try {
                    const polist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/opened`, {
                        headers: {
                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                        }
                    });
    
                    let number = 0;
                    let poLinks = polist.data.result;
    
                    // filter used PO
                    if (listed.length > 0) {
                        // filter used PO
                        for( const [key,value] in listed ) {
                            poLinks.splice(poLinks.findIndex(({idpoproduk}) => idpoproduk === listed[key].idpoproduk), 1);
                        }
                    }
    
                    updatedPoLink(poLinks.map((v) => {
                        number+=1;
                        return { ...v, no: number };
                    }));
    
                } catch (err) {
                    console.log(err);
                }
            };
            submitPo();
            // setTimeout(() => navigate(`/dashboard/po/detail/${tmpIdproduk}`), 2300);
        }
    };

    const [valCustomToSubmit, setValCustomToSubmit] = useState({});
    const customValues = {};
    const handleChangePoCustom = (e) => {
        customValues[e.target.name] = e.target.value;
        setValCustomToSubmit((prevVals) => {
            return { ...prevVals, [e.target.name] : e.target.value };
        });
    };

    // HANDLE PO SUBMIT CUSTOM
    const handleSubmitPoCustom = (e) => {
        setSubmitting(true);
        e.preventDefault();
        let sum = 0;
        const errorStok = [];

        const data = {
            input_length: inputQty.length,
            input_data: valCustomToSubmit
        };

        if (withStok) {
            for (let i = 0; i < inputQty.length; i++) {
                sum += parseInt(valCustomToSubmit[`qty_${i}`]);
                for(let j = 0; j < 3; j++) {
                    if(valCustomToSubmit[`kategori_${i}_${j}`].stok < parseInt(valCustomToSubmit[`qty_${i}`])) {
                        errorStok.push(
                            {
                                idpo: valCustomToSubmit[`kategori_${i}_${j}`].idpo,
                                message: `Order ${valCustomToSubmit[`kategori_${i}_${j}`].variant} melebihi stok`
                            }
                        );
                    }
                }
            }
            data.input_with_stok = true;
        } else {
            for (let i = 0; i < inputQty.length; i++) {
                sum += parseInt(valCustomToSubmit[`qty_${i}`]);
            }
        }

        if( Object.keys(valCustomToSubmit).length === 0 || sum === 0) {
            setOpenAlert(true);
            setAlertStatus('warning');
            setAlertMessage('Data kosong !');
            setSubmitting(false);

        } else if (errorStok.length > 0 && withStok) {
            setOpenAlert(true);
            setAlertStatus('error');
            setAlertMessage('Order melebihi stok !');
            setSubmitting(false);

        } else {

            const submitPo = async () => {
                try {
                    await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/custom/create`, data, {
                        headers: {
                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                        }
                    });
                    handleCloseModalPoCustom();

                    setOpenAlert(true);
                    setAlertStatus('success');
                    setAlertMessage('Permintaan pre-order telah dikirim !');
                    await getData();
                } catch (err) {
                    console.log(err);
                    setSubmitting(false);
                    setWithStok(false);
                }
            };

            const getData = async () => {
                try {
                    const polist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/list`, {
                        headers: {
                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                        }
                    });
                    let number = 0;
                    await updatedData(polist.data.result.map((v) => {
                        number+=1;
                        return { ...v, no: number };
                    }));
                    await getOpenedPo(polist.data.result);
                } catch (err) {
                    console.log(err);
                }
            };
    
            const getOpenedPo = async (listed) => {
                try {
                    const polist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/opened`, {
                        headers: {
                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                        }
                    });
    
                    let number = 0;
                    let poLinks = polist.data.result;
    
                    // filter used PO
                    if (listed.length > 0) {
                        // filter used PO
                        for( const [key,value] in listed ) {
                            poLinks.splice(poLinks.findIndex(({idpoproduk}) => idpoproduk === listed[key].idpoproduk), 1);
                        }
                    }
    
                    updatedPoLink(poLinks.map((v) => {
                        number+=1;
                        return { ...v, no: number };
                    }));
    
                } catch (err) {
                    console.log(err);
                }
            };

            submitPo();
        }
    };

    const handleValToSubmit = (e, el) => {
        el.value = parseInt(e.target.value);
        el.total = el.value * el.harga;
        setValToSubmit({
            ...valToSubmit,
            [`po_${el.idpodetail}`]: el
        });
    };

    const [maxPcs, setMaximumPcs] = useState(null);

    const handleOpenModalPo = (idpoproduk) => {
        const getFormPo = async () => {
            try {
                const poform = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/${idpoproduk}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                let number = 0;
                const arrPoForm = [];
                const arrStok = [];

                poform.data.result.kategori.forEach(el => {
                    el.detail.forEach(elDetail => {
                        elDetail.idpoproduk = el.idpoproduk;
                        elDetail.idpo = el.idpo;
                        arrPoForm.push(elDetail);
                    });
                    arrStok.push({ idpo: el.idpo, idpoproduk: el.idpoproduk, namakategori: el.namakategori, stok: el.stok });
                });
                if (poform.data.result.jenis_po === "PO dengan Stok") setWithStok(true);
                if (poform.data.result.idpoproduk === 238) setMaximumPcs(6);
                await setPoForm(arrPoForm);
                await setStokInfo(arrStok);
                await setOpenModalPo(true);

            } catch (err) {
                console.log(err);
            }
        };
        getFormPo();
        setTmpIdproduk(idpoproduk);
    };

    // PO Custom
    const [dataColumnLoop, setDataColumnLoop] = useState([]);
    const [inputQty, setStateInputQty] = useState([]);
    const handleAddColumn = () => {
        setStateInputQty((prevVals) => {
            const newInput = prevVals.sort((a, b) => b.input - a.input)[0].input + 1;
            return [...prevVals, { kategori: dataColumnLoop, input: newInput }];
        });
    }

    const handleOpenModalPoCustom = (idpoproduk) => {
        const getFormPoCustom = async () => {
            try {
                const poformCustom = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/${idpoproduk}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                let number = 0;
                const arrColumn = [];
                const arrPoFormCustom = [];
                const arrStok = [];

                poformCustom.data.result.kategori.forEach(el => {
                    el.detail.forEach(elDetail => {
                        elDetail.idpoproduk = el.idpoproduk;
                        elDetail.idpo = el.idpo;
                        elDetail.stok = el.stok;
                        arrPoFormCustom.push(elDetail);
                    });
                    arrStok.push({ idpo: el.idpo, idpoproduk: el.idpoproduk, namakategori: el.namakategori, stok: el.stok });
                });

                for (let i = 0; i < 3; i++) {
                    arrColumn.push(arrPoFormCustom);
                }
                console.log(arrColumn);
                setDataColumnLoop(arrColumn);
                setStateInputQty((prevVals) => {
                    return [...prevVals, { kategori: arrColumn, input: 0 }];
                });

                if (poformCustom.data.result.jenis_po === "PO dengan Stok") setWithStok(true);
                await setStokInfo(arrStok);
                await setOpenModalPoCustom(true);

            } catch (err) {
                console.log(err);
            }
        };
        getFormPoCustom();
        setTmpIdproduk(idpoproduk);
    };

    const handleCloseModalPo = () => {
        setMaximumPcs(null);
        setOpenModalPo(false);
        setOpeningModalPo(false);
        setSubmitting(false);
        setWithStok(false);
        setStokInfo([]);
        setPoForm([]);
        setValToSubmit({});
    };

    const handleCloseModalPoCustom = () => {
        setMaximumPcs(null);
        setOpenModalPoCustom(false);
        setOpeningModalPo(false);
        setSubmitting(false);
        setWithStok(false);
        setStokInfo([]);
        setStateInputQty([]);
        setValCustomToSubmit({});
        setDataColumnLoop([]);
    };

    const [openModalPoRocela, setOpenModalPoRocela] = useState(false);
    const [openModalPoGoura, setOpenModalPoGoura] = useState(false);
    const [openModalPoCustomGabungan, setOpenModalPoCustomGabungan] = useState(false);

    return (
        <Container>
            <Snackbar
                open={openAlert}
                autoHideDuration={2500}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                key={'top' + 'center'}
            >
                <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            {/* MODAL PO LAMA */}
            <Modal
              open={openModalPo}
              onClose={handleCloseModalPo}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={modalStyle}>
                <form onSubmit={handleSubmitPo}>
                    <Grid container spacing={2} sx={{ maxHeight: '75vh', overflow: 'auto' }}>
                        <Grid item xs={12} sx={{ textAlign: 'center' }}>
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Form pre-order {withStok ? `dengan stok` : `tanpa stok`}
                            </Typography>
                        </Grid>
                        {maxPcs !== null && (
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Typography id="modal-modal-title" variant="subtitle2" >
                                    <b>(maximum 6 PCS)</b>
                                </Typography>
                            </Grid>
                        )}
                        {withStok && (
                            <TableContainer component={Paper}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><Typography variant="subtitle2" fontWeight="700">Kategori</Typography></TableCell>
                                            <TableCell><Typography variant="subtitle2" fontWeight="700">Stok</Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {stokInfo.map((el) => (
                                        <TableRow>
                                            <TableCell><Typography variant="body2">{el.namakategori}</Typography></TableCell>
                                            <TableCell><Typography variant="body2">{el.stok}</Typography></TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                        {poForm.map((el) => (
                            <Grid item xs={6} sx={{ paddingX: 1, paddingY: 2 }}>
                                <InputLabel sx={{ whiteSpace: 'normal', minHeight: '42px', fontSize: '13px' }}>
                                    {el.variant}
                                </InputLabel>
                                <TextField
                                    size="small"
                                    fullWidth
                                    required
                                    type="number"
                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*',  min: 0 } }
                                    id="outlined-basic"
                                    variant="outlined"
                                    defaultValue={0}
                                    onChange={(e) => handleValToSubmit(e, el)}
                                />
                            </Grid>
                        ))}
                        <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                            <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                        </Grid>
                    </Grid>
                </form>
              </Box>
            </Modal>

            {/* MODAL PO BARU */}
            <Modal
              open={openModalPoCustom}
              onClose={handleCloseModalPoCustom}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={modalStyle}>
                <form onSubmit={handleSubmitPoCustom}>
                    <Grid container spacing={2} sx={{ maxHeight: '75vh', overflow: 'auto' }}>
                        <Grid item xs={12} sx={{ textAlign: 'center' }}>
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Form Pre-Order custom {withStok ? `dengan stok` : `tanpa stok`}
                            </Typography>
                        </Grid> 
                        <Grid container spacing={2}>
                            <Grid item xs={12} sx={{ paddingX: 1}}>
                                <Button variant="contained" size="small" onClick={handleAddColumn}>Tambah Pack</Button>
                            </Grid>
                            {inputQty.map((inputElement) => (
                                <>
                                    <Grid item xs={12}>
                                        <InputLabel sx={{ whiteSpace: 'normal' }}>
                                            Produk
                                        </InputLabel>
                                    </Grid>
                                    {inputElement.kategori.map((el, i) => (
                                        <Grid item xs={4} key={poForm.map} sx={{ paddingX: 1 }}>
                                            <Select
                                                name={`kategori_${inputElement.input}_${i}`}
                                                size="small"
                                                fullWidth
                                                labelId="formPoCustom"
                                                id="demo-simple-select"
                                                onChange={handleChangePoCustom} 
                                            >
                                                {el.map((item) => (
                                                    <MenuItem key={item.idpodetail} value={item}>
                                                        {item.variant}&nbsp;<b>{withStok ? `(${item.stok})` : ``}</b>
                                                    </MenuItem> 
                                                ))}
                                            </Select>
                                        </Grid>
                                    ))}
                                    <Grid item xs={12}>
                                        <InputLabel sx={{ whiteSpace: 'normal', fontSize: '0.75rem' }}>
                                            Pack
                                        </InputLabel>
                                        <TextField
                                            name={`qty_${inputElement.input}`}
                                            size="small"
                                            fullWidth
                                            required
                                            type="number"
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*',  min: 1 } }
                                            id="outlined-basic"
                                            variant="outlined"
                                            defaultValue={0}
                                            onChange={handleChangePoCustom}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                </>
                            ))}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                        <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                    </Grid>
                </form>
              </Box>
            </Modal>
            {openingModalPo && (
                <CircularProgress 
                    color="secondary" 
                    sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '999'}}
                />
            )}
            {/* MODAL PO CUSTOM */}
            <Modal
                open={openModalPoRocela}
                onClose={() => setOpenModalPoRocela(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Typography variant="subtitle1">
                        PO Custom saat ini hanya tersedia di versi web lama (V1.0.0).
                    </Typography>
                    <Typography variant="subtitle2">
                        Silahkan login ke web lama untuk melihat atau membuat PO Custom
                    </Typography>
                    <br/>
                    <Button variant="contained" href="https://wnj.web.id/distributor">Login V1</Button>
                </Box>
            </Modal>

            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ margin: '10px 14px'}}>
                    <Typography variant="h5" fontWeight="700">Pre order</Typography>
                </Grid>
                <Grid item xs={12} sx={{ margin: '10px 14px'}}>
                    <Typography variant="subtitle1" fontWeight="700">Daftar link PO</Typography>
                </Grid>
                <Grid item xs={12} sx={{ paddingY: '22px' }}>
                    <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
                        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: '380px' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Link PO</Typography></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {opData.map((row) => (
                                <TableRow
                                    key={row.idbpo}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell align="center">
                                        <Stack>
                                            <Button
                                                disabled={openingModalPo || Date.parse(row.tgl) <= Date.parse(new Date)}
                                                fullWidth
                                                variant="contained"
                                                onClick={() => {
                                                    setOpeningModalPo(true);
                                                    if (row.custom.split('|')[1] === 'Ya') {
                                                        setTimeout(() => handleOpenModalPoCustom(row.idpoproduk), 100);
                                                    } else setTimeout(() => handleOpenModalPo(row.idpoproduk), 100);
                                                }}
                                            >
                                                {row.namapo}
                                            </Button>
                                            <Typography variant="subtitle2" color="darkgray" fontWeight="700">
                                                <Countdown date={new Date(row.tgl)} renderer={renderer} />
                                            </Typography>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align="center">
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => setOpenModalPoRocela(true)}
                                    >
                                        PO Custom Rocela
                                    </Button>
                                    <Typography variant="subtitle2" color="darkgray" fontWeight="700">
                                        <Countdown date={new Date('2023-09-16 23:59:00')} renderer={renderer} />
                                    </Typography>
                                </TableCell>
                            </TableRow>

                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align="center">
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => setOpenModalPoRocela(true)}
                                    >
                                        PO Custom Goura
                                    </Button>
                                    <Typography variant="subtitle2" color="darkgray" fontWeight="700">
                                        <Countdown date={new Date('2023-09-16 23:59:00')} renderer={renderer} />
                                    </Typography>
                                </TableCell>
                            </TableRow>

                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align="center">
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => setOpenModalPoRocela(true)}
                                    >
                                        PO Custom Bundling
                                    </Button>
                                    <Typography variant="subtitle2" color="darkgray" fontWeight="700">
                                        <Countdown date={new Date('2023-09-16 23:59:00')} renderer={renderer} />
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            {opData.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">
                                        <Typography variant="subtitle1" style={{ color: 'grey' }}>
                                            Link po belum ada atau telah digunakan semua
                                        </Typography>    
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12} sx={{ margin: '10px 14px'}}>
                    <Typography variant="subtitle1" fontWeight="700">Daftar PO</Typography>
                </Grid>
                <Grid item xs={12} sx={{ paddingY: '22px' }}>
                    <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">No</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Tanggal</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle2" fontWeight="700">Nama PO</Typography></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody align="center">
                            {/* {JSON.stringify(data[0].no)} */}
                            {data.map((row) => (
                                <TableRow
                                    key={row.idpomitra}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell>{row.no}</TableCell>
                                    <TableCell align="right">{row.tgl}</TableCell>
                                    <TableCell align="left">
                                        <Link to={`/dashboard/po/detail/${row.idpoproduk}`}>{row.namapo}</Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {data.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">
                                        <Typography variant="subtitle1" style={{ color: 'grey' }}>Data PO kosong</Typography>    
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Container>
    )
};

export default PreOrder;
